const STATISTIC = '/statistic';

export function statistic(): string {
  return STATISTIC;
}

export function statisticAndroidVersions() {
  return `${STATISTIC}/android-versions`;
}
